module.exports = __webpack_public_path__ + "media/images/riders/small/DANNY_HART-832670a73ff187bda916c1822652c106.png";